module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-41.c8b71201.jpg";